import React from "react";
import { Helmet } from "react-helmet";

const CanonicalTag = ({ url }) => {
  return (
    <Helmet>
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default CanonicalTag;
